import { store } from "~/state/store";
import { isDetailActive } from "~/util/detail";
import { reviewHasColoredBadge } from "~/util/review";

/* eslint-disable */
const MARKERS_TITLE_POSITION = ["right", "top", "bottom", "left"];
const MARKERS_MOVE_POSITION = [{
	left: 10,
}, {
	left: -10,
}, {
	top: -10,
}, {
	top: -10,
	left: 10,
}, {
	top: -10,
	left: -10,
}];

interface ISceneMarker {
	[key: string]: any;
}

interface ICoords {
	x: number;
	y: number;
}

interface IMarkerBBOX {
	lt: ICoords;
	rb: ICoords;
}

interface ITitleBBOX extends IMarkerBBOX {
	position: string;
}

interface IMarkersBBOx {
	marker: IMarkerBBOX;
	title?: ITitleBBOX;
}

interface IMovedCoords {
	coords: ICoords,
	count: number,
}

interface IMoveMarker {
	markerPadding?:{
		left?: number;
		top?: number;
	},
	movedCoords?: Array<IMovedCoords>
}

/**
 * vyreseni kolizi textu a badgu u markeru
 */
export function resolveTitleCollision(markers: Array<ISceneMarker>, markersBBox: Array<IMarkersBBOx>): Array<ISceneMarker> {
	// eslint-disable-next-line no-console
	console.time("Collision resolve time");

	let rmLittleM = [];
	const selectType = ["big", "middle", "small", "universal", "universalbig"];
	const copyMarkers = markers.slice();
	const copyMarkersBBox = markersBBox.slice();
	copyMarkers.reverse();
	copyMarkersBBox.reverse();

	for (let i = 0; i < copyMarkers.length; i++) {
		const m = copyMarkers[i];
		const mConf = m.getConf();

		// chceme prochazet jen urcite typy marekru (souhlasi s markery na danne strance)
		if (selectType.indexOf(mConf.type.name) > -1) {
			const actMBBox  = copyMarkersBBox[i].marker;
			const review = m.getPOI().review;
			const checkbadgeCollision = !!(review && reviewHasColoredBadge(review));
			let collision = false;
			let actRmLittleM = [];
			let tBBox = null;
			let textPosition = "";

			// vypocitame si bbox pro titulek, levy horni a pravy dolni roh
			const tBBoxs = generateTitleBBox(actMBBox, checkbadgeCollision);

			// vypocitame si bbox pro badge, levy horni a pravy dolni roh
			const bBBox = {
				lt: {
					x: actMBBox.lt.x + 21,
					y: actMBBox.rb.y - 31 - 22,
				},
				rb: {
					x: actMBBox.lt.x + 21 + 22,
					y: actMBBox.rb.y - 31,
				},
			};

			for (let p = 0; p < MARKERS_TITLE_POSITION.length; p++) {
				tBBox = tBBoxs[MARKERS_TITLE_POSITION[p]];

				if (!tBBox) {
					continue;
				}

				actRmLittleM = [];
				collision = false;

				// projdeme vsechny markery, zda nedochazi ke kolizi titulku
				for (let y = 0; y < copyMarkers.length; y++) {
					if (copyMarkers[y] === m || rmLittleM.indexOf(copyMarkers[y]) > -1) {
						continue;
					}

					// kolize s jinym markerem
					const mBBox = copyMarkersBBox[y].marker;
					if (isCollision(mBBox, tBBox)) {
						if (copyMarkers[y].getConf().type.name === "little") {
							actRmLittleM.push(copyMarkers[y]);
						}
						else {
							collision = true;
							break;
						}
					}

					// kolize s jiz zobrazenym titulkem u jineho markeru
					const mtBBox = copyMarkersBBox[y].title;
					if (mtBBox) {
						for (let tb = 0; tb < MARKERS_TITLE_POSITION.length; tb++) {
							const mtbb = mtBBox[MARKERS_TITLE_POSITION[tb]];

							if (mtbb && isCollision(mtbb, tBBox)) {
								collision = true;
								break;
							}
						}

						if (collision) {
							break;
						}
					}
				}

				if (!collision) {
					textPosition = MARKERS_TITLE_POSITION[p];
					break;
				}
			}

			// pokud se nejedna o kolizi a budeme text zobrazovat, ulozime si bbox titulku k bboxu markeru pro pocitani dalsich kolizi
			if (!collision) {
				copyMarkersBBox[i].title = tBBoxs;
				rmLittleM = rmLittleM.concat(actRmLittleM);
			}

			m.showFirmBadge(true);

			if (textPosition != "") {
				m.showTitleText(!collision, textPosition);
			}
		}
		else {
			m.showTitleText(false);
		}
	}

	// nejspise nebude potreba prekreslovat vrstvu, tak zatim zakomentovat
	/*requestAnimationFrame(() => {
		this._layer.redraw();
	});*/

	if (isDetailActive(store.getState())) {
		resolveDetailCollision(markers, copyMarkersBBox);
	}

	// eslint-disable-next-line no-console
	console.timeEnd("Collision resolve time");

	return rmLittleM;
}

export function resolveDetailCollision(markers: Array<ISceneMarker>, markersBBox: Array<IMarkersBBOx>): void {
	const copyMarkers = markers.slice();
	const copyMarkersBBox = markersBBox.slice();

	if (isDetailActive(store.getState())) {
		const detailMarker = Mapy.getComponent("detail").getMarker();

		if (detailMarker) {
			const review = detailMarker.getPOI().review;
			const titleBBox = generateTitleBBox(detailMarker.getBBox(), !!(review && reviewHasColoredBadge(review)), detailMarker.titlePosition);

			for (let i = 0; i < copyMarkersBBox.length; i++) {
				if (copyMarkersBBox[i].title && copyMarkers[i] && copyMarkersBBox[i].title[copyMarkers[i].titlePosition]) {
					let collision = isCollision(titleBBox, copyMarkersBBox[i].title[copyMarkers[i].titlePosition]);
					copyMarkers[i]?.showTitleText(!collision, copyMarkers[i].titlePosition);
				}
			}
		}
	}
	else {
		for (let i = 0; i < copyMarkersBBox.length; i++) {
			if (copyMarkersBBox[i].title && copyMarkers[i]) {
				copyMarkers[i]?.showTitleText(true, copyMarkers[i].titlePosition);
			}
		}
	}
}

export function moveMarkerOnSamePlace(marker: ISceneMarker, markers: Array<ISceneMarker>, movedCoords: Array<IMovedCoords> = []): IMoveMarker {
	let moveMarkerParams: IMoveMarker = {
		movedCoords,
	};

	for (let i = 0; i < markers.length; i++) {
		let m = markers[i];
		let coords1 = coordsRound(marker.getCoords());
		let coords2 = coordsRound(m.getCoords());

		if (coords1.x === coords2.x && coords1.y === coords2.y) {
			let moveTo = 0;

			for (let c = 0; c < movedCoords.length; c++) {
				const mc = movedCoords[c];

				if (mc.coords.x === coords1.x && mc.coords.y === coords1.y) {
					moveTo = mc.count;
					mc.count++;
				}
			}

			if (moveTo === 0) {
				movedCoords.push({
					coords: coords1,
					count: 1,
				});
			}

			const multiplier = Math.floor(moveTo / MARKERS_MOVE_POSITION.length) + 1;
			let padding = {
				...MARKERS_MOVE_POSITION[(moveTo % MARKERS_MOVE_POSITION.length)]
			};

			for (let p in padding) {
				padding[p] *= multiplier;
			}

			moveMarkerParams = {
				movedCoords,
				markerPadding: padding,
			}
			break;
		}
	}

	//console.log("---------", moveMarkerParams);

	return moveMarkerParams;
}

function coordsRound(coords) {
	return {
		x: Math.round(coords.x*1e10)/1e10,
		y: Math.round(coords.y*1e10)/1e10,
	}
}

/**
 * vrati informaci o tom, zda jsou dva bboxy v kolizi
 * @param {Object} firstBBox - prvni porovnavany objekt s levym hornim rohem a pravym dolnim rohem v px
 * @param {Object} secondBBox - druhy porovnavany objekt s levym hornim rohem a pravym dolnim rohem v px
 * @returns {Boolean}
 */
function isCollision(firstBBox: IMarkerBBOX, secondBBox: IMarkerBBOX): boolean {
	return firstBBox.rb.x > secondBBox.lt.x
	&& firstBBox.rb.y > secondBBox.lt.y
	&& firstBBox.lt.x < secondBBox.rb.x
	&& firstBBox.lt.y < secondBBox.rb.y;
}

/**
 * generovani objektu s moznostmi pozice textu u markeru
 * @param {Object} mBBox - bbox k markeru ke kteremu budeme pozice titulku pocitat
 * @param {Boolean} badge - pokud je badge musi se vrchni pozice upravit
 * @param {String} position - pokud mame pevne definovanou pozici, vezmeme jen tu
 * @returns {Object}
 */
function generateTitleBBox(mBBox: IMarkerBBOX, badge: boolean, position?: string) {
	// pozadovane presny postup pozicovani, nejprve vpravo, pak zkusit nahore, pak dole a pak vlevo od markeru
	const textWidth = Mapy.CUS.search?.titleTextBlockWidth ? parseInt(Mapy.CUS.search?.titleTextBlockWidth) + 4 : 112; // max sirka textu, zatim pocitame s ni (valikost + potrebne paddingy)
	const textHeight = 30; // max vyska textu zatim pocitame s ni (velikost + potrebne paddingy)
	const badgeOverlap = 8; // presah badge nad markerem
	const pos: {
		right?: ITitleBBOX;
		top?: ITitleBBOX;
		bottom?: ITitleBBOX;
		left?: ITitleBBOX;
	} = {};

	// pozice titulku vpravo od markeru
	pos.right = {
		lt: {
			x: mBBox.rb.x,
			y: mBBox.lt.y + (mBBox.rb.y - mBBox.lt.y) / 2 - textHeight / 2,
		},
		rb: {
			x: mBBox.rb.x + textWidth,
			y: mBBox.lt.y + (mBBox.rb.y - mBBox.lt.y) / 2 + textHeight / 2,
		},
		position: "right",
	};

	if (badge) {
		pos.right.lt.y = mBBox.rb.y - textHeight;
		pos.right.rb.y = mBBox.rb.y;
	}

	// pozice titulku nahore od markeru
	pos.top = {
		lt: {
			x: mBBox.lt.x + (mBBox.rb.x - mBBox.lt.x) / 2 - textWidth / 2,
			y: mBBox.lt.y - textHeight - (badge ? badgeOverlap : 0),
		},
		rb: {
			x: mBBox.lt.x + (mBBox.rb.x - mBBox.lt.x) / 2 + textWidth / 2,
			y: mBBox.lt.y,
		},
		position: "top",
	};

	// pozice titulku dole od markeru
	pos.bottom = {
		lt: {
			x: mBBox.lt.x + (mBBox.rb.x - mBBox.lt.x) / 2 - textWidth / 2,
			y: mBBox.rb.y,
		},
		rb: {
			x: mBBox.lt.x + (mBBox.rb.x - mBBox.lt.x) / 2 + textWidth / 2,
			y: mBBox.rb.y + textHeight,
		},
		position: "bottom",
	};

	// pozice titulku vlevo od markeru
	pos.left = {
		lt: {
			x: mBBox.lt.x - textWidth,
			y: mBBox.lt.y + (mBBox.rb.y - mBBox.lt.y) / 2 - textHeight / 2,
		},
		rb: {
			x: mBBox.lt.x,
			y: mBBox.lt.y + (mBBox.rb.y - mBBox.lt.y) / 2 + textHeight / 2,
		},
		position: "left",
	};

	return position ? pos[position] : pos;
}
